import { useDictionaryStore } from 'bz-utilities/dictionary/dictionary-store';
import useDictionarySentence from 'bz-utilities/dictionary/hooks/sentence';
import withDisplayName from 'bz-utilities/hoc/display-name';
import useComputed from 'bz-utilities/hooks/computed';
import { observer } from 'mobx-react';
import type React from 'react';
import { useEffect } from 'react';

export interface IProps extends React.PropsWithChildren {
  title?: string;
}

const DocumentTitle = observer(
  withDisplayName((props: IProps) => {
    const { loading, data } = useDictionaryStore();
    const fallback = useDictionarySentence('{TM3}');

    const title = useComputed(() => {
      if (loading || Object.values(data).length === 0) return '...Loading...';
      const { title = '{TM3}' } = props;

      const wrappedTitle = title.split('>').map((x) => {
        const trimmed = x.trim().split(' ');
        const wrapped = trimmed.map((t) => {
          if (!t.startsWith('{')) {
            t = `{${t}`;
          }

          if (!t.endsWith('}')) {
            t = `${t}}`;
          }

          return t;
        });

        return wrapped.join(' ');
      });
      return wrappedTitle.join(' > ');
    }, [loading, data, props]);

    const documentTitle = useDictionarySentence(title);

    useEffect(() => {
      document.title = documentTitle;
      return () => {
        document.title = fallback;
      };
    }, [documentTitle, fallback]);

    return <>{props.children}</>;
  }, 'DocumentTitle')
);

export default DocumentTitle;
